<template>
    <div class="kpi">
        <!-- v-infinite-scroll="getSerialList" -->
        <van-list v-model="loading" :finished="finished" @load="onLoad" :finished-text="(dataList.length) ? finishedText : '暂无数据'" :immediate-check="false" offset="200">
            <!-- <div class="kpi" infinite-scroll-disabled="finished" v-infinite-scroll="getSerialList" infinite-scroll-immediate="scrollImmediate" infinite-scroll-distance="100"> -->
            <div class="header">
                <div class="head-warp">
                    <div class="total">
                        <p class="name">总积分</p>
                        <p class="val">{{ kpiScore.sumScore || 0 }}</p>
                    </div>
                    <div class="day flex">
                        <div class="item flex-item" :class="{'actived': tabIndex === 0}" @click="changeTab(0)">
                            <p class="name">网约车积分</p>
                            <p class="val">{{ kpiScore.expTotalScore || 0 }}</p>
                        </div>
                        <div class="item flex-item" :class="{'actived': tabIndex === 1}" @click="changeTab(1)">
                            <p class="name">代驾积分</p>
                            <p class="val">{{ kpiScore.djTotalScore || 0 }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <dl class="performance-box">
                <dt class="kpi-title flex">
                    <span>{{typeName}}今日积分</span>
                </dt>
                <dd class="performance-item flex vux-1px-b" v-for="(item,i) in todayScoreList" :key="i" todayScoreList>
                    <p class="name">{{item.name}}</p>
                    <p class="val">{{ item.value }}
                    </p>
                </dd>
            </dl>
            <dl class="performance-box">
                <dt class="kpi-title flex">
                    <span>全部分类明细</span>
                </dt>
                <dd class="performance-item flex vux-1px-b" @click="goTypeDetail(item)" v-for="(item) in performanceClass" :key="item.itemType">
                    <p class="name">{{ item.kpiTypeStr }}</p>
                    <p class="val">{{ item.kpiTypeScore || item.score }}<van-icon style="margin-left:.4rem;" name="arrow"></van-icon>
                    </p>
                </dd>
            </dl>

            <dl class="performance-box">
                <dt class="kpi-title flex">
                    <span>全部流水</span>
                    <p class="flex" @click="screeningVisible = !screeningVisible">筛选 <i class="arrow"></i></p>
                </dt>
                <div v-for="(lists,index) in dataList" :key="'lists_'+index">
                    <dd class="flow-time">{{ lists.createTime || '-' }}</dd>
                    <dd class="flow-item performance-item flex vux-1px-b" v-for="(list,k) in lists.dataList" :key="'list_'+k" @click="detail(list)">
                        <div>
                            <p>{{ list.kpiCategoryStr }}</p>
                            <p class="flow-type">
                                <span>{{ list.dayTime || '-' }}</span>
                                <span>{{ list.kpiTypeStr }}</span>
                            </p>
                        </div>
                        <div style="font-weight: 600">{{ list.score > 0 ? '+' + list.score :list.score }}分</div>
                    </dd>
                </div>
            </dl>
            <!-- <div v-if="finished&&dataList.length>0" style="padding:1rem;text-align:center;color: #999999;">暂无更多数据～</div> -->
            <van-popup v-model="screeningVisible" position="bottom" closeOnClickModal="true" round>
                <div class="pop-box">
                    <div>
                        <p class="type-title">类别</p>
                        <div class="flex type-btns">
                            <p @click="switchType(item)" v-for="item in serialTypeOptions" :key="item.value" :class="{'actived': item.actived}">{{ item.label }}</p>
                        </div>
                    </div>
                    <div>
                        <p class="type-title">时间段</p>
                        <div class="flex type-btns">
                            <p @click="switchType(item, gapOptions)" v-for="item in gapOptions" :class="item.actived ? 'actived' : ''" :key="item.value">{{ item.label }}</p>
                        </div>
                    </div>
                    <div class="foot-btn flex">
                        <van-button type="default" @click="reset" class="foot-btn-van resetClass">重置</van-button>
                        <van-button type="default" @click="ensure" class="foot-btn-van mackSureClass">确定</van-button>
                    </div>
                </div>
            </van-popup>
            <!-- </div> -->
        </van-list>
    </div>
</template>
<script>
import mobileType from "../../utils/mobileType";
import utils from "../../utils/util";
// import pullRefresh from "../../../components/pullRefresh.vue";
import {
    statisticalNew,
    serialListNew,
    getSerialListGroupByKpiType
} from "../../apis/complain/index";
export default {
    name: "performanceList",
    // components: {
    //     pullRefresh,
    // },
    data() {
        return {
            kpiScore: {},
            pageId: "0",
            dataList: [],
            finished: false,
            performanceClass: [],
            daijiaPerformanceClass: [],
            screeningVisible: false,
            searchOptions: {
                strategyInt: null, // 积分分类
                serialType: null, // 1 加分 2减分
                startTime: null,
                endTime: null,
                timeGap: 7
            },
            serialTypeOptions: [
                {
                    label: "增加项",
                    value: 1,
                    actived: true
                },
                {
                    label: "扣除项",
                    value: 2,
                    actived: true
                }
            ],
            gapOptions: [
                {
                    label: "近7天",
                    value: 7,
                    actived: true
                },
                {
                    label: "近1个月",
                    value: 30,
                    actived: false
                },
                {
                    label: "近3个月",
                    value: 90,
                    actived: false
                }
            ],
            currentPage: 1,
            tabIndex: 1, // 0:网约车,1:代驾
            scrollImmediate: false,
            loading: false,
            params: {
                scale: "2.0",
                areaCode: "110105",
                sysVersion: "14.7",
                token:
                    "MTAxNzAwMTE1NTA4OjcwMDoyMDIzMDExODAxMDQ1MzQyMzpmZmZmZmZmZi04MTNhLTk4Y2MtZmZmZi1mZmZmZWYwNWFjNGE=",
                appChannel: "AppStore",
                platform: "2",
                softVersion: "1.2.51",
                display: "1334*750",
                role: "2",
                uuidString: "7021747C-162F-46D9-8761-99AA3621013A",
                channel: "1020000000",
                cityCode: "110100",
                idfv: "912FD003-76D6-4DAC-B98C-4B6FFF5A00C6"
            },
            timer: null,
            finishedText: "暂无数据"
        };
    },
    created() {
        // this.getKpiScore();
        // this.getExpDriverKpiTotal();
        // this.getSerialList()
        window.getDataFromNative = this.getDataFromNative;
    },
    mounted() {
        this.getUserInfoFromApp();
    },
    computed: {
        typeName() {
            return this.tabIndex === 1 ? "代驾" : "网约车";
        },
        todayScoreList() {
            let {
                djTotayScore,
                djTotayAverageScore,
                expTotayScore,
                expTotayAverageScore
            } = this.kpiScore;
            return [
                {
                    name: "今日总积分",
                    value:
                        (this.tabIndex == 1 ? djTotayScore : expTotayScore) || 0
                },
                {
                    name: "今日平均积分",
                    value:
                        (this.tabIndex == 1
                            ? djTotayAverageScore
                            : expTotayAverageScore) || 0
                }
            ];
        },
        selectPerformanceClass() {
            return this.tabIndex == 1
                ? this.performanceClass
                : this.daijiaPerformanceClass;
        }
    },
    methods: {
        getUserInfoFromApp() {
            let params = {
                methodName: "getDataFromNative", //定义与原生的方法名(固定)
                type: 1 //业务类型(固定)
            };
            if (mobileType.isIOS()) {
                window.webkit.messageHandlers.getDataFromVue.postMessage(
                    params
                );
            } else if (mobileType.isAndroid()) {
                window.Android.getDataFromVue(JSON.stringify(params));
            }
        },
        // formatDateAll(data) {
        //     return util.formatDateAll(new Date(data), "MM-dd hh:mm:ss");
        // },
        getDataFromNative(params) {
            if (mobileType.isIOS()) {
                this.params = params;
            } else if (mobileType.isAndroid()) {
                this.params = JSON.parse(params);
            }
            this.getKpiScore();
            this.getExpDriverKpiTotal();
            this.getSerialList();
        },
        changeTab(v) {
            if (this.tabIndex != v) {
                this.tabIndex = +v;
                this.dataList = [];
                this.currentPage = 1;
                this.finished = false;
                this.getSerialList();
                this.getExpDriverKpiTotal();
            }
        },
        // 查询全部分类
        async getExpDriverKpiTotal(tab) {
            let params = { ...this.params };
            params.data = JSON.stringify({
                isDj: this.tabIndex
            });
            let res = await getSerialListGroupByKpiType(params);
            if (res.code == 1) {
                let list = JSON.parse(res.data) || [];
                console.log(list);
                this.performanceClass = list;
            }
        },
        // 总积分统计查询
        async getKpiScore() {
            let params = { ...this.params };
            let res = await statisticalNew(params);
            if (res.code == 1) {
                this.kpiScore = JSON.parse(res.data);
            }
        },
        // 积分流水列表
        async getSerialList() {
            this.dealTimeRange(this.searchOptions.timeGap);
            let params = { ...this.params };
            params.data = JSON.stringify({
                isDj: this.tabIndex,
                pageSize: 8,
                currentPage: this.currentPage,
                ...this.searchOptions
            });
            try {
                this.currentPage++;
                const res = await serialListNew(params);
                if (res.code == 1) {
                    let resData = JSON.parse(res.data);
                    console.log(resData);
                    this.dataList =
                        resData && resData.length > 0
                            ? this.dataList.concat(resData)
                            : this.dataList;
                    this.refreshing = false;
                    // 若请求没有数据，则加载完成，finished设置为true
                    if (!resData || resData.length == 0) {
                        this.finished = true;
                        this.finishedText = "没有更多数据啦";
                    }
                } else {
                    this.finished = true;
                    this.$toast(res.msg);
                }
            } catch (error) {
                console.log(error);
            }
        },
        transTime(time, type) {
            if (!time) {
                return false;
            }
            let date = new Date(time.replace(/-/g, "/"));
            let y = date.getFullYear();
            let m =
                date.getMonth() + 1 < 10
                    ? "0" + (date.getMonth() + 1)
                    : date.getMonth() + 1;
            let d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            if (type == 1) {
                return y + "年" + m + "月" + d + "日";
            } else {
                return time.substr(-8, 5);
            }
        },
        // 查看流水详情
        detail(list) {
            localStorage.setItem("kpi", JSON.stringify(list));
            this.$router.push({
                name: "performanceDetail",
                query: {
                    id: list.id,
                    isDj: this.tabIndex,
                    driverId: list.driverId || ""
                }
            });
        },
        switchType(rowData, data) {
            if (data) data.forEach(item => (item.actived = false));
            rowData.actived = !rowData.actived;
        },
        reset() {
            this.serialTypeOptions.forEach(item => {
                item.actived = true;
            });
            this.gapOptions.forEach(item => {
                if (item.value == 7) {
                    item.actived = true;
                } else {
                    item.actived = false;
                }
            });
        },
        ensure() {
            this.dataList = [];
            let serialActiveList = this.serialTypeOptions
                .filter(item => item.actived)
                .map(item => item.value);
            if (!serialActiveList.length) {
                this.$toast("请选择类别");
                return false;
            }
            if (serialActiveList.length > 1) {
                // 加减项全选
                this.searchOptions.serialType = null;
            } else {
                this.searchOptions.serialType = serialActiveList[0];
            }
            let timeGap = this.gapOptions.filter(item => item.actived)[0].value;
            if (!timeGap) {
                this.$toast("请选择时间段");
                return false;
            }
            this.searchOptions.timeGap = timeGap;
            this.finished = false;
            this.currentPage = 1;
            this.screeningVisible = false;
            this.getSerialList();
        },
        //从分类入口进入流水列表
        goTypeDetail(rowData) {
            this.$router.push({
                name: "performanceTypeDetail",
                query: {
                    strategyInt: rowData.kpiType,
                    kpiTypeStr: rowData.kpiTypeStr,
                    isDj: this.tabIndex
                }
            });
        },
        dealTimeRange(gap = 7) {
            let date = new Date();
            let timeStamp = date.valueOf();
            let startTime = null;
            if (gap == 7) {
                startTime = new Date(timeStamp - 7 * 24 * 60 * 60 * 1000);
                this.searchOptions.startTime = this.transTime(startTime);
            } else if (gap == 30) {
                startTime = new Date(timeStamp - 30 * 24 * 60 * 60 * 1000);
                this.searchOptions.startTime = this.transTime(startTime);
            } else if (gap == 90) {
                startTime = new Date(timeStamp - 90 * 24 * 60 * 60 * 1000);
                this.searchOptions.startTime = this.transTime(startTime);
            }
            this.searchOptions.endTime = this.transTime(timeStamp, true);
        },
        transTime(time, isEndTime = false) {
            if (!time) {
                return false;
            }
            let date = new Date(time);
            let y = date.getFullYear();
            let m =
                date.getMonth() + 1 < 10
                    ? "0" + (date.getMonth() + 1)
                    : date.getMonth() + 1;
            let d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            if (isEndTime) {
                return y + "-" + m + "-" + d + " 23:59:59";
            }
            return y + "-" + m + "-" + d + " 00:00:00";
        },
        onLoad() {
            this.loading = false;
            // 设置定时器做节流处理，避免滚动时频繁触发加载事件
            if (!this.timer) {
                this.timer = setTimeout(() => {
                    this.getSerialList();
                    // 清除定时器，释放内存
                    this.timer = null;
                }, 500);
            }
        }
    }
};
</script>
<style lang="less" scoped>
.performance-box {
    padding: 0 16px;
    background: #fff;
    color: #333;
}
.flow-time {
    margin: 0 -16px;
    padding: 14px 16px;
    background: rgba(245, 245, 245, 0.94);
    color: #666666;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
}

.performance-item {
    justify-content: space-between;
    font-size: 0.7rem;
    padding: 0.75rem 0;
    border-bottom: 1px solid #ebedf0;
    &:last-child {
        border-bottom: none;
    }
    .name {
        color: #323233;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 20px;
    }
    .val {
        color: #666666;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
    }
}

.flow-item {
    padding: 12px 0 12px 16px;
    font-size: 16px;
    .flow-type {
        font-size: 14px;
        color: #999;
        margin-top: 2px;
        span {
            font-size: 14px;
            margin-right: 0.62rem;
        }
    }

    &.flex {
        align-items: start;
    }
}

.foot-btn {
    text-align: center;
    justify-content: space-between;
    margin-top: 3.75rem;
    .foot-btn-van {
        width: 162px;
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 24px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        line-height: 48px;
        &.resetClass {
            background: #fff;
            color: #fe4f51;
            border-color: #fe4f51;
            // border-image: linear-gradient(270deg, rgba(230, 0, 18, 1), rgba(254, 79, 81, 1)) 1 1;
        }
        &.mackSureClass {
            color: #fff;
            border-color: #fe4f51;
            background: linear-gradient(270deg, #e60012 0%, #fe4f51 100%);
        }
    }
    .mint-button {
        font-size: 0.8rem;
        width: 7.8rem;
        height: 2.2rem;
    }
}

.pop-box {
    padding: 6px 18px 44px 18px;
    border-radius: 10px 10px 0px 0px;
    .type-title {
        padding: 12px 0;
        font-weight: 600;
        font-size: 16px;
        color: #000;
    }

    .type-btns {
        justify-content: flex-start;
        margin-bottom: 1rem;

        p {
            background: #f2f2f2;
            border-radius: 4px;
            text-align: center;
            font-size: 12px;
            height: 32px;
            line-height: 32px;
            margin-right: 20px;
            width: 100px;
            height: 32px;
            background: #f2f2f2;

            &.actived {
                background: rgba(254, 79, 81, 0.1);
                // border-color: rgba(242, 98, 41, 0.4);
                color: #fe4f51;
            }
            &:last-child {
                margin-right: 0;
            }
        }
    }
}

.flex {
    display: flex;
    align-items: center;

    .flex-item {
        flex: 1;
    }
}

.kpi {
    background: rgba(245, 245, 245, 0.94);
    min-height: 100vh;
    .header {
        position: relative;
        top: 0;
        left: 0;
        width: 100%;
        // height: 9.6rem;
        background-color: #fff;
        border-radius: 0;

        .head-warp {
            height: 9.7rem;
            padding: 1.8rem 0.8rem 0.8rem;
            background: #fff;
            box-shadow: 0px 4px 10px 0px rgba(88, 102, 132, 0.16);
            border-radius: 0px 0px 0.75rem 0.75rem;

            .total {
                margin-left: 1.2rem;
                color: #333;
                font-weight: bold;
                .name {
                    font-size: 1.06rem;
                }

                .val {
                    font-size: 2rem;
                    margin-top: 0.5rem;
                    line-height: 2rem;
                }
            }

            .day {
                margin: 0 1.2rem;
                margin-top: 1.8rem;
                .item {
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    // height: 4.4rem;
                    font-size: 0.95rem;
                    color: #333;
                    background: rgba(255, 255, 255, 0.1);
                    border-radius: 0.6rem;
                    text-align: left;
                    .name {
                        margin-top: 0.2rem;
                    }
                    .val {
                        margin-top: 0.4rem;
                        font-size: 1.3rem;
                        font-weight: bold;
                    }
                    &:first-of-type {
                        margin-right: 0.75rem;
                    }
                    &.actived:before {
                        position: absolute;
                        top: -0.1rem;
                        content: "";
                        width: 17px;
                        height: 4px;
                        background: #f26229;
                    }
                }
            }
        }
    }

    .kpi-title {
        font-size: 1.05rem;
        color: #333;
        background-color: #fff;
        padding: 1.5rem 0 1rem 0;
        justify-content: space-between;
        align-items: center;
        span {
            padding: 0 0.62rem;
            font-weight: 600;
            position: relative;
            &:before {
                position: absolute;
                left: 0;
                top: 0.2rem;
                content: "";
                width: 0.25rem;
                height: 1.05rem;
                background: #f36c36;
            }
        }
        p {
            font-size: 15px;
            font-weight: 600;
            position: relative;
            align-content: center;
            .arrow {
                border: 6px solid;
                border-bottom-width: 0;
                border-color: #999999 transparent transparent transparent;
                height: 0px;
                margin-left: 5px;
                border-radius: 6px;
            }
        }
    }

    .yo-scroll {
        min-height: 8rem;
    }

    .list {
        .date {
            font-size: 0.75rem;
            height: 2.4rem;
            line-height: 2.4rem;
            padding: 0 0.8rem;
            background-color: #f5f5f5;
        }

        .items {
            background-color: #fff;
            padding: 0 1.6rem;

            .item {
                height: 3.2rem;
                padding: 0.6rem 0;
                border-bottom: 1px solid #ebebeb;

                &:first-child {
                    border-top: 1px solid #ebebeb;
                }

                .left {
                    .name {
                        font-size: 0.75rem;
                        color: #333;
                        line-height: 1.05rem;
                    }

                    .info {
                        font-size: 0.65rem;
                        color: #999;
                        line-height: 0.9rem;

                        .time {
                            margin-right: 0.5rem;
                        }
                    }
                }

                .right {
                    width: 5rem;
                    font-size: 0.75rem;
                    color: #666;
                    text-align: right;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    word-break: break-all;
                    white-space: nowrap;
                }
            }
        }
    }
}
</style>
